import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Gift, Sparkles, Zap, BadgePercent } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface SignupPromoDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function SignupPromoDialog({ open, onOpenChange }: SignupPromoDialogProps) {
  const navigate = useNavigate();

  const handleClaim = () => {
    onOpenChange(false);
    navigate("/auth?mode=signup&promo=welcome-plus");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md border-primary/30 bg-card overflow-hidden p-0">
        <div className="relative bg-gradient-to-br from-primary/15 via-primary/5 to-transparent px-6 pt-8 pb-6">
          <div className="absolute -top-12 -right-12 h-32 w-32 rounded-full bg-primary/20 blur-3xl" />
          <div className="relative flex flex-col items-center text-center">
            <div className="mb-4 inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/15 ring-1 ring-primary/30">
              <Gift className="h-7 w-7 text-primary" />
            </div>
            <h2 className="font-display text-2xl font-bold text-foreground tracking-tight">
              Get 1 free week of Plus
            </h2>
            <p className="mt-2 text-sm text-muted-foreground max-w-sm">
              Sign up today and unlock GatorNotes Plus — on us, for a full week.
            </p>
          </div>
        </div>

        <div className="px-6 pb-6">
          <ul className="space-y-3 mb-6">
            <li className="flex items-start gap-3 text-sm">
              <BadgePercent className="h-5 w-5 text-primary shrink-0 mt-0.5" />
              <span className="text-foreground"><span className="font-semibold">15% off</span> every note on the marketplace</span>
            </li>
            <li className="flex items-start gap-3 text-sm">
              <Sparkles className="h-5 w-5 text-primary shrink-0 mt-0.5" />
              <span className="text-foreground"><span className="font-semibold">Unlimited</span> premium AI tutor, flashcards & quizzes</span>
            </li>
            <li className="flex items-start gap-3 text-sm">
              <Zap className="h-5 w-5 text-primary shrink-0 mt-0.5" />
              <span className="text-foreground">Priority visibility for any notes you list</span>
            </li>
          </ul>

          <Button
            variant="hero"
            size="lg"
            className="w-full font-semibold"
            onClick={handleClaim}
          >
            Sign up & claim my free week
          </Button>
          <button
            onClick={() => onOpenChange(false)}
            className="mt-3 block w-full text-center text-xs text-muted-foreground hover:text-foreground transition-colors"
          >
            No thanks, maybe later
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
